import React from "react";
import { motion } from "framer-motion";
import { MapPin, Navigation } from "lucide-react";
import { SITE } from "../data/content";

export const ServiceArea = () => {
  return (
    <section id="service-area" data-testid="service-area-section" className="py-24 bg-background">
      <div className="px-6 md:px-12 lg:px-24">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Text + towns */}
          <div>
            <span className="text-accent font-semibold text-sm uppercase tracking-wider">Where we work</span>
            <h2 className="mt-3 text-3xl md:text-4xl font-bold tracking-tight text-foreground">
              Serving Edmonton & surrounding areas
            </h2>
            <p className="mt-4 text-muted-foreground text-lg">
              We cover Edmonton and the towns within roughly 50&nbsp;km. If you're nearby and don't see your town listed, just give us a call—we likely cover you too.
            </p>

            <div className="mt-7 flex flex-wrap gap-2.5" data-testid="service-area-towns">
              {SITE.serviceAreas.map((town, i) => (
                <motion.span
                  key={town}
                  data-testid={`area-chip-${i}`}
                  initial={{ opacity: 0, y: 12 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.35, delay: i * 0.05 }}
                  className="inline-flex items-center gap-2 rounded-sm border border-border bg-card px-4 py-2 text-sm font-medium text-foreground"
                >
                  <MapPin className="w-4 h-4 text-accent" /> {town}
                </motion.span>
              ))}
            </div>

            <div className="mt-7 flex items-center gap-3 rounded-sm bg-[hsl(var(--brand-green))]/15 text-accent font-semibold px-4 py-3">
              <Navigation className="w-5 h-5 shrink-0" /> {SITE.serviceRadiusNote}
            </div>
          </div>

          {/* Map */}
          <motion.div
            data-testid="service-area-map"
            initial={{ opacity: 0, scale: 0.97 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative rounded-sm overflow-hidden border border-border shadow-sm"
          >
            <iframe
              title="Prairie Cleanout Services area map — Edmonton & surrounding areas"
              src="https://www.google.com/maps?q=Edmonton,Alberta,Canada&z=9&output=embed"
              className="w-full h-[420px]"
              style={{ border: 0 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};
